// @ts-check

import {
  requestRejected,
  requestResolved,
  responseRejected,
  responseResolved
} from '@/api/interceptors'
import axios from 'axios'
import axiosBetterStacktrace from 'axios-better-stacktrace'

const API_BASE_URL = process.env.VUE_APP_API_URL || ''

const instance = axios.create({
  baseURL: API_BASE_URL
})

if (typeof jest === 'undefined') {
  axiosBetterStacktrace(instance)
}

instance.interceptors.request.use(requestResolved, requestRejected)
instance.interceptors.response.use(responseResolved, responseRejected)

export const api = instance

export default instance
